import { useEffect } from 'react';

import companyStore from '../store/CompanyStore';
import { resolveCompanyDisplay } from '../helper/consultActions';

// 회사 표시 정보 — 레지스트 기본값으로 즉시 렌더하고 서버 응답이 오면 덮어쓴다.
//
// 함수형 화면 전용이며 companyStore 를 구독하므로 호출부는 observer 여야 한다.
// 클래스 컴포넌트는 훅을 못 쓰므로 resolveCompanyDisplay 를 직접 부른다.
export const useCompany = (registryEntry) => {
  const companyId = registryEntry.id;

  useEffect(() => {
    companyStore.fetchCompany(companyId);
  }, [companyId]);

  return resolveCompanyDisplay(companyStore.company, registryEntry);
};
